import { render, staticRenderFns } from "./save-documentation-file-dialog.component.vue?vue&type=template&id=050e89ee"
import script from "./save-documentation-file-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-documentation-file-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050e89ee')) {
      api.createRecord('050e89ee', component.options)
    } else {
      api.reload('050e89ee', component.options)
    }
    module.hot.accept("./save-documentation-file-dialog.component.vue?vue&type=template&id=050e89ee", function () {
      api.rerender('050e89ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/save-documentation-file-dialog/save-documentation-file-dialog.component.vue"
export default component.exports